import React, { createRef, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Actions from "../../../../payments/duck/actions";
import SearchIcon from "../../../../../lib/components/Icons/SearchIcon";

export default function BillingStateSelectionComponent({
  className,
  setModalState,
  Countries,
  selectedBillingCountry,
  setSelectedBillingCountry,
  restSelectedBillingState,
  placeholder = "",
}) {
  const dispatch = useDispatch();
  useEffect(() => {
    refs[selectedBillingCountry]?.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }, []);
  const refs = Countries.reduce((acc, value) => {
    acc[value.name] = createRef();
    return acc;
  }, {});
  function renderList() {
    return Countries.map((country, idx) => (
      <button
        key={idx}
        ref={refs[country.name]}
        onClick={() => {
          if (
            selectedBillingCountry === "India" &&
            country.name !== selectedBillingCountry
          ) {
            // User chose india and changing it's country
            // to other than india so reset billing state.
            restSelectedBillingState();
          }

          setSelectedBillingCountry({
            name: country.name,
            code: country.code,
          });
          dispatch(
            Actions.setLocation({
              country: country.name,
              countryCode: country.code,
            })
          );

          setModalState("BreakUp");
        }}
        className={`w-full cursor-pointer p-3.5 text-left ${
          selectedBillingCountry === country.name ? "text-blue-600" : ""
        }`}
      >{`${country.name}`}</button>
    ));
  }

  const [input, setInput] = useState("");
  const handleChange = (e) => {
    setInput(e.target.value);
  };

  if (input.length > 0) {
    Countries = Countries.filter((i) => {
      return i.name.toLowerCase().match(input.toLowerCase());
    });
  }

  return (
    <section
      className={
        "flex flex-col  font-serif" + (className ? " " + className : "")
      }
    >
      <div className="flex sticky top-0 items-center border-b">
        <input
          className={"outline-none h-16 px-4 w-full rounded-lg"}
          type="text"
          value={input}
          onChange={handleChange}
          placeholder={
            placeholder.length !== 0 ? placeholder : "Search Billing Country"
          }
          autoFocus
        />
        <SearchIcon className="h-5" />
      </div>
      <div>{renderList()}</div>
    </section>
  );
}
